import {
    createAction,
} from '@shared/common';

const TYPE_NAMESPACE = 'DATA';

const updatePayload = ({updated, deleted}) => ({updated, deleted});

export const load = createAction(
    `${TYPE_NAMESPACE}/LOAD`,
    (password) => ({password}),
);

export const tour = {
    updated: createAction(
        `${TYPE_NAMESPACE}/TOUR/UPDATED`,
        updatePayload,
    ),
    edit: createAction(
        `${TYPE_NAMESPACE}/TOUR/EDIT`,
        ({
             name,
             internal,
             showAddress,
             street,
             city,
             zip,
             showMap,
             latitude,
             longitude,
             contact,
             password,
             showLogo,
             showBottom,
             showGreeter,
         }) => ({
             name,
             internal,
             showAddress,
             street,
             city,
             zip,
             showMap,
             latitude,
             longitude,
             contact,
             password,
             showLogo,
             showBottom,
             showGreeter,
         }),
    ),
    deletePreview: createAction(
        `${TYPE_NAMESPACE}/TOUR/DELETEPREVIEW`,
    ),
};

export const floor = {
    updated: createAction(
        `${TYPE_NAMESPACE}/FLOOR/UPDATED`,
        updatePayload,
    ),
    create: createAction(
        `${TYPE_NAMESPACE}/FLOOR/CREATE`,
        ({tour_id, name}) => ({tour_id, name}),
    ),
    edit: createAction(
        `${TYPE_NAMESPACE}/FLOOR/EDIT`,
        ({tour_id, floor_id, name}) => ({tour_id, floor_id, name}),
    ),
    delete: createAction(
        `${TYPE_NAMESPACE}/FLOOR/DELETE`,
        ({floor_id, tour_id}) => ({floor_id, tour_id}),
    ),
    deleteFloorplan: createAction(
        `${TYPE_NAMESPACE}/FLOOR/DELETEFLOORPLAN`,
        ({floor_id, tour_id}) => ({floor_id, tour_id}),
    ),
    reorder: {
        request: createAction(
            `${TYPE_NAMESPACE}/FLOOR/REORDER/REQUEST`,
            ({tour_id, sortlist}) => ({tour_id, sortlist}),
        ),
        failure: createAction(
            `${TYPE_NAMESPACE}/FLOOR/REORDER/FAILURE`,
            (error) => ({error}),
        ),
        success: createAction(
            `${TYPE_NAMESPACE}/FLOOR/REORDER/SUCCESS`,
            (data) => ({data}),
        ),
    },
};

export const room = {
    updated: createAction(
        `${TYPE_NAMESPACE}/ROOM/UPDATED`,
        updatePayload,
    ),
    create: createAction(
        `${TYPE_NAMESPACE}/ROOM/CREATE`,
        ({floor_id, name}) => ({floor_id, name}),
    ),
    edit: createAction(
        `${TYPE_NAMESPACE}/ROOM/EDIT`,
        ({floor_id, room_id, name, start_rotation}) => ({floor_id, room_id, name, start_rotation}),
    ),
    delete: createAction(
        `${TYPE_NAMESPACE}/ROOM/DELETE`,
        ({room_id}) => ({room_id}),
    ),
    reorder: {
        request: createAction(
            `${TYPE_NAMESPACE}/ROOM/REORDER/REQUEST`,
            ({floor_id, sortlist}) => ({floor_id, sortlist}),
        ),
        failure: createAction(
            `${TYPE_NAMESPACE}/ROOM/REORDER/FAILURE`,
            (error) => ({error}),
        ),
        success: createAction(
            `${TYPE_NAMESPACE}/ROOM/REORDER/SUCCESS`,
            (data) => ({data}),
        ),
    },
};

export const infopoint = {
    updated: createAction(
        `${TYPE_NAMESPACE}/INFOPOINT/UPDATED`,
        updatePayload,
    ),
    edit: createAction(
        `${TYPE_NAMESPACE}/INFOPOINT/EDIT`,
        ({infopoint_id, linked_room_id, u, v, title, symbol, text}) =>
            ({infopoint_id, linked_room_id, u, v, title, symbol, text}),
    ),
    save: createAction(
        `${TYPE_NAMESPACE}/INFOPOINT/SAVE`,
        ({floor_id, room_id, linked_room_id, u, v, title, symbol, text}) =>
            ({floor_id, room_id, linked_room_id, u, v, title, symbol, text}),
    ),
    remove: createAction(
        `${TYPE_NAMESPACE}/INFOPOINT/REMOVE`,
        ({infopoint_id}) => ({infopoint_id}),
    ),
};

export const global = {
    updated: createAction(
        `${TYPE_NAMESPACE}/GLOBAL/UPDATED`,
        ({base_url, base_url_embed}) => ({base_url, base_url_embed}),
    ),
};

